import {
    GET_STUDENTS_FAIL,
    GET_STUDENTS_SUCCESS,
    ADD_STUDENT_SUCCESS,
    ADD_STUDENT_FAIL,
    UPDATE_STUDENT_SUCCESS,
    UPDATE_STUDENT_FAIL,
    DELETE_STUDENT_SUCCESS,
    DELETE_STUDENT_FAIL,

    GET_STUDENT_BY_UUID_FAIL,
    GET_STUDENT_BY_UUID_SUCCESS,
    


} from "./actionTypes";

const INIT_STATE = {
    students: [],
    error: null,
    loading: true,
    student: {}
};

const studentReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des students
        case GET_STUDENTS_SUCCESS:
            return {
                ...state,
                students: action.payload, // tableau d'objets student
                loading: false,
                error: null
            };

        case GET_STUDENTS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une studente
        case ADD_STUDENT_SUCCESS:
            return {
                ...state,
                students: [action.payload, ...state.students], // ajoute au début du tableau
                error: null
            };

        case ADD_STUDENT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une studente
        case UPDATE_STUDENT_SUCCESS:
            return {
                ...state,
                students: state.students.map(student =>
                    student.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet student
                        : student
                ),
                error: null
            };

        case UPDATE_STUDENT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une studente
        case DELETE_STUDENT_SUCCESS:
            return {
                ...state,
                students: state.students.filter(
                    student => student.id !== action.payload
                ),
                error: null
            };


        case DELETE_STUDENT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        
        // --------------------- SINGLE STUDENT ---------------------
        
        case GET_STUDENT_BY_UUID_SUCCESS:
            return {
                ...state,
                loading: false,
                student: action.payload
            };
        case GET_STUDENT_BY_UUID_FAIL:
            return {
                ...state,
                loading: false,
                student: null,
                error: action.payload
            };

        default:
            return state;
    }
};

export default studentReducer;
